import React from "react";
import { Modal, Form, Row, Col } from "react-bootstrap";
import { labels } from "../../../localization/labels";
import SubmitControl from "../SubmitControl";
import SubmitButton from "../SubmitButton/SubmitButton";
import EditableLink from "../EditableLink";
import { Affix } from "antd";
import CommonUtil from "../../../utils/CommonUtil";

const getDefaultInputFields = (noDescription, noDateRange) => {
  const inputFields = [
    {
      label: labels.name,
      controlId: "name",
      placeholder: labels.namePlaceholder,
      type: "text"
    }
  ];

  if (noDescription === undefined) {
    const inputField = {
      label: labels.description,
      controlId: "description",
      placeholder: labels.descriptionPlaceholder,
      as: "textarea"
    };
    inputFields.push(inputField);
  }

  if (noDateRange === undefined) {
    const inputField = {
      label: labels.dateFromTo,
      controlId: "dateFromTo",
      placeholder: [labels.dateFromPlaceholder, labels.dateToPlaceholder],
      type: "dateRange"
    };
    inputFields.push(inputField);
  }
  return inputFields;
};

const getRows = props => {
  const defaultInputFields = getDefaultInputFields(
    props.entity.noDescription,
    props.entity.noDateRange
  );
  const inputFields = props.additionalInputFields
    ? defaultInputFields.concat(props.additionalInputFields)
    : defaultInputFields;
  const rows = [];

  for (let i = 0; i < inputFields.length; i++) {
    const inputField = inputFields[i];
    rows.push(
      <Row>
        <Col sm="3">
          <Form.Label className="Label">{inputField.label}</Form.Label>
        </Col>
        <Col>
          <Form.Group controlId={inputField.controlId}>
            {inputField.type === "link" ? (
              <EditableLink
                title={inputField.label}
                value={props.entity[inputField.controlId]}
                placeholder={inputField.placeholder}
                validationRule={
                  props.validationRules &&
                  props.validationRules[inputField.controlId]
                }
                changeLinkValue={props.onChange}
                maxLength={props.maxLength.uri}
              />
            ) : (
              <SubmitControl
                autoFocus={i === 0}
                type={inputField.type}
                placeholder={inputField.placeholder}
                value={props.entity[inputField.controlId]}
                validationRule={
                  props.validationRules &&
                  props.validationRules[inputField.controlId]
                }
                onChange={props.onChange}
                maxLength={props.maxLength.name}
                controlId={inputField.controlId}
                as={inputField.as}
              ></SubmitControl>
            )}
          </Form.Group>
        </Col>
      </Row>
    );
  }
  return rows;
};

const BasicDialog = props => {
  return (
    <>
      <Modal
        show={props.show}
        onHide={props.handleClose}
        onEntered={props.handleEntered}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {CommonUtil.constructHeaderTitleAndId(
              props.dialogTitle,
              props.entity.id
            )}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form
            onSubmit={e => {
              e.preventDefault();
            }}
          >
            {getRows(props)}
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Affix offsetBottom={true}>
            <SubmitButton type="close" onClick={props.handleClose} />
            <SubmitButton
              type="save"
              onClick={props.onSave}
              disabled={props.disabled}
            />
          </Affix>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default BasicDialog;
